import { BsShieldFillX, BsShieldExclamation } from "react-icons/bs";
import { RiShieldStarFill } from "react-icons/ri";

const ShieldIconExclamation = (
  <div className="shield-icon">
    <BsShieldExclamation />
  </div>
);

const ShieldIconStar = (
  <div className="shield-icon">
    <RiShieldStarFill />
  </div>
);

const ShieldIconGreenX = (
  <div className="shield-icon-green">
    <BsShieldFillX />
  </div>
);

export const IncidentEvent: { [key: string]: { message: string; shieldIcon: JSX.Element } } = {
  BURGLAR_ALARM_TRIGGERED: {
    message: 'Burglar Alarm Triggered',
    shieldIcon: ShieldIconExclamation,
  },
  TIME_EXPIRED: {
    message: 'Timer has run out',
    shieldIcon: ShieldIconStar,
  },
  cs001: {
    message: 'Event is processed by agent',
    shieldIcon: ShieldIconStar,
  },
  cs999: {
    message: 'Event has been closed',
    shieldIcon: ShieldIconStar,
  },
  cso001: {
    message: 'Event is processed by agent',
    shieldIcon: ShieldIconStar,
  },
  cso999: {
    message: 'Event has been closed',
    shieldIcon: ShieldIconStar,
  },
  cso005: {
    message: 'ADT has notified police',
    shieldIcon: ShieldIconStar,
  },
  eu006: {
    message: 'Police Requested',
    shieldIcon: ShieldIconStar,
  },
  eu005: {
    message: 'Burglar Alarm Canceled',
    shieldIcon: ShieldIconGreenX,
  },
};
